export enum USER_ROLES {
  ALL = "*",
  SUPER_ADMIN = "superAdmin",
  TENANT_ADMIN = "tenantAdmin",
  ORGANIZATION_ADMIN = "orgAdmin",
  CLAIM_MANAGER = "claimManager",
  CLAIMANT = "claimant",
  REHAB_MANAGER = "rehabManager",
  EMPLOYER = "employer"
}
